// extracted by mini-css-extract-plugin
export default {"container":"Np-z","bubbleNav":"Op-z","graphic":"Pp-z","contact":"Qp-z"};